import { render, staticRenderFns } from "./Numeric.vue?vue&type=template&id=52e7add2&scoped=true&"
import script from "./Numeric.vue?vue&type=script&lang=js&"
export * from "./Numeric.vue?vue&type=script&lang=js&"
import style0 from "./Numeric.vue?vue&type=style&index=0&id=52e7add2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7add2",
  null
  
)

export default component.exports